<!-- Basemap Selector -->
@if(layers()) {
  <div
    class="absolute left-4 bottom-20 bg-white/80 backdrop-blur-sm rounded-xl shadow-xl border border-gray-200/50 cursor-pointer z-30 transition-all duration-300 ease-out hover:shadow-2xl hover:scale-105 hover:bg-white/90 group"
    (click)="openGallery()">

    <!-- Active basemap preview with indicator -->
    <div class="relative p-2" [appTooltip]="(selectedBaseMap()?.get('title') || selectedBaseMap()?.get('display_name')) || 'Select Basemap'" position="right">
      <img
        id="active_basemap_tile"
        [src]="selectedBaseMap() ? 'assets/images/basemaps/' + getLayerImageName(selectedBaseMap()) + '.png' : 'assets/images/basemaps/Topographic_(theLIST).png'"
        class="h-10 w-10 rounded-lg object-cover border border-gray-200 shadow-sm"
        alt="Active basemap"
        onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0yNCAxMkMyNi4yMDkxIDEyIDI4IDEzLjc5MDkgMjggMTZDMjggMTguMjA5MSAyNi4yMDkxIDIwIDI0IDIwQzIxLjc5MDkgMjAgMjAgMTguMjA5MSAyMCAxNkMyMCAxMy43OTA5IDIxLjc5MDkgMTIgMjQgMTJaIiBmaWxsPSIjOUNBM0FGIi8+CjxwYXRoIGQ9Ik0yNCAyOEMyNi4yMDkxIDI4IDI4IDI5Ljc5MDkgMjggMzJDMjggMzQuMjA5MSAyNi4yMDkxIDM2IDI0IDM2QzIxLjc5MDkgMzYgMjAgMzQuMjA5MSAyMCAzMkMyMCAyOS43OTA5IDIxLjc5MDkgMjggMjQgMjhaIiBmaWxsPSIjOUNBM0FGIi8+Cjwvc3ZnPgo='" />


      <!-- Hover tooltip -->
      <!-- <div class="absolute bottom-full left-1/2 transform -translate-x-[-50px] -translate-y-[-50px] mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
        {{ (selectedBaseMap()?.get('title') || selectedBaseMap()?.get('display_name')) || 'Select Basemap' }}
      </div> -->
    </div>
  </div>

  <!-- Basemap Gallery -->
  <div
    #gallery
    class="absolute bottom-20 left-20 bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-200/50 z-30 max-w-md"
    [style.display]="isOpen() ? 'block' : 'none'"
    (blur)="lostFocus()"
    tabindex="0">

    <!-- Gallery Header -->
    <div class="flex items-center justify-between p-4 border-b border-gray-100">
      <div class="flex items-center gap-2">
        <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
          <i class="fas fa-map text-blue-600 text-sm"></i>
        </div>
        <h3 class="text-lg font-semibold text-gray-900">Basemaps</h3>
      </div>
      <button
        (click)="openGallery()"
        class="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center justify-center transition-colors duration-200">
        <i class="fas fa-times text-gray-600 text-sm"></i>
      </button>
    </div>

    <!-- Gallery Content -->
    <div class="p-4">
      <!-- Basemap Grid -->
      <div class="grid grid-cols-2 gap-3">

          @for (layer of layers(); track $index) {
            @if (layer) {
              <div
                class="group relative bg-gray-50 hover:bg-gray-100 rounded-xl p-3 cursor-pointer transition-all duration-200 hover:shadow-md border-2 border-transparent hover:border-blue-200"
                [class.bg-blue-50]="selectedBaseMap()?.get('title') === layer.get('title') || selectedBaseMap()?.get('display_name') === layer.get('display_name')"
                [class.border-blue-300]="selectedBaseMap()?.get('title') === layer.get('title') || selectedBaseMap()?.get('display_name') === layer.get('display_name')"
                (click)="setBaseMapVisible(layer)">

                <!-- Basemap thumbnail -->
                <div class="relative mb-3">
                  <img
                    [src]="'assets/images/basemaps/' + getLayerImageName(layer) + '.png'"
                    class="w-full h-12 rounded-lg object-cover border border-gray-200 shadow-sm group-hover:shadow-md transition-shadow duration-200"
                    [alt]="layer.get('title') || layer.get('display_name')" />

                </div>

                <!-- Basemap name -->
                <p class="text-xs font-medium text-gray-700 leading-tight text-center group-hover:text-gray-900 transition-colors duration-200">
                  {{ (layer.get('title') || layer.get('display_name')) | truncateText: 20 }}
                </p>
              </div>
            }
          }


      </div>

      <!-- Footer info -->
      <div class="mt-4 pt-3 border-t border-gray-100">
        <p class="text-xs text-gray-500 text-center">
          Click any basemap to switch the background
        </p>
      </div>
    </div>
  </div>
}
